'use client';

import { useAtomValue } from 'jotai';
import Button, { ButtonVariants } from '../../../components/Button';
import deviceScreenSize, { ScreenSize } from '../../../store/deviceScreenSize';
import styles from './CasesBlock.module.scss';

const ViewAllButton = () => {
  const deviceSize = useAtomValue(deviceScreenSize);
  const isMobile = deviceSize === ScreenSize.MOBILE;

  return (
    !isMobile ? (
      <Button
        variant={ButtonVariants.OUTLINED}
        className={styles.linkButton}
        link='/cases'
        icon={(
          <svg className={styles.linkIcon}>
            <use
              xlinkHref='/media/icon-nest.svg#iconNest'
              href='/media/icon-nest.svg#iconNest'
            />
          </svg>
              )}
      >
        view all cases
      </Button>
    ) : null
  );
};

export default ViewAllButton;
